import { Mixins, Component, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentModel from '@/views/Attachment/model/attachment'

@Component({
    name: 'attachment-btn',
    inheritAttrs: false,
})
export default class AttachmentBtn extends Mixins<MixinInterface>() {
    @Prop() requirments!: Record<string, any>
    @VModel() loading!: boolean

    fileInput = null

    get generalRequirments() {
        return this.requirments
            ? this.requirments
            : this.$store.getters.attachmentConstraints.maxBytes
            ? this.$store.getters.attachmentConstraints
            : this.getFileRequirements()
    }

    get allowedFileTypes() {
        return this.generalRequirments?.allowedExtensions
            ? `.${this.generalRequirments?.allowedExtensions.join(',.')}`
            : ''
    }

    get maxBytes() {
        return this.generalRequirments.maxBytes
    }

    openFilemanager() {
        document.getElementById('attachment-input')?.click()
    }

    async uploadFile(files: FileList) {
        if (files.length > 0) {
            let attachments: Array<any> = []
            this.loading = true
            this.$emit('loadingAttachment', true)
            await Promise.all(
                Array.from(files).map(async (file) => {
                    let res = await AttachmentModel.postFile(file)
                    attachments.push(res)
                })
            )
            this.$emit('passFiles', attachments)
            this.loading = false
            this.$emit('loadingAttachment', false)
        }
    }
}
